import React from "react";
import { Box, Stack } from "@mui/material";

/**
 * Mobile: Customer → General → Service → Equipment (single column).
 * md+: left column Customer + Service, right column General + Equipment (no tall empty cell beside Customer).
 */
export default function ContractDetailTwoColumnLayout({
  renderCustomer,
  renderGeneral,
  renderService,
  renderEquipment,
}) {
  return (
    <Stack spacing={3}>
      <Box sx={{ display: { xs: "flex", md: "none" }, flexDirection: "column", gap: 3 }}>
        {renderCustomer?.()}
        {renderGeneral()}
        {renderService()}
        {renderEquipment()}
      </Box>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "row",
          alignItems: "flex-start",
          gap: 3,
          "& > *": { flex: 1, minWidth: 0 },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {renderCustomer?.()}
          {renderService()}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {renderGeneral()}
          {renderEquipment()}
        </Box>
      </Box>
    </Stack>
  );
}
